




































































































































import { IAlert, IAlertListRequest } from "@/types/alert";
import { IPost, IPostListRequest } from "@/types/post";
import { ITicket, ITicketListRequest } from "@/types/ticket";
import { IUser } from "@/types/user";
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";

@Component({
  components: {},
})
export default class extends Vue {
  @Action("ticket/salesGetList")
  public getTickets!: (params: ITicketListRequest) => Promise<void>;

  @Getter("ticket/list")
  public tickets!: ITicket[];

  @Mutation("ticket/clear")
  public clearTickets!: () => void;

  @Action("post/salesGetList")
  public getPosts!: (params: IPostListRequest) => Promise<void>;

  @Getter("post/list")
  public posts!: IPost[];

  @Mutation("post/clear")
  public clearPosts!: () => void;

  @Action("alert/salesGetList")
  public getAlerts!: (params: IAlertListRequest) => Promise<void>;

  @Getter("alert/list")
  public alerts!: IAlert[];

  @Getter("auth/me")
  public me!: IUser;

  private async created() {
    this.clearTickets();
    this.clearPosts();

    await Promise.all([
      this.getTickets({
        per_page: 5,
        charge_id: this.me.id,
        inprogress: true,
        sort_by: "deadline_at",
        sort_desc: false,
      }),
      this.getPosts({ per_page: 10, sort_by: "created_at", sort_desc: true }),
      this.getAlerts({ per_page: 0, sort_by: "created_at", sort_desc: true }),
    ]);
  }
}
